import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export default function UeberUns() {
  return (
    <div data-testid="page-ueber-uns">
      {/* Header */}
      <section className="px-6 md:px-12 lg:px-24 pt-32 md:pt-40 pb-16">
        <div className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-primary mb-6">
          <span className="inline-block w-2 h-2 bg-accent" />
          Über uns
        </div>
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-light tracking-tighter leading-[1.05] max-w-4xl">
          Ein Familien&shy;unternehmen mit Sinn für <em className="italic">Maß und Material</em>.
        </h1>
      </section>

      {/* Editorial body */}
      <section className="px-6 md:px-12 lg:px-24 pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-7 lg:col-start-2 space-y-8 text-foreground/90 leading-relaxed">
            <p className="text-lg">
              <span className="font-serif text-6xl float-left leading-none mr-3 mt-1 text-primary">K</span>
              eppel Immobilien ist ein inhabergeführtes Familienunternehmen aus
              Oberfranken. Wir kaufen kleinere Mehrfamilienhäuser, sanieren sie
              über mehrere Jahre behutsam und führen sie anschließend dauerhaft
              in unsere eigene Verwaltung über.
            </p>

            <p>
              Wir glauben, dass gute Häuser Geduld brauchen. Statt schneller
              Margen suchen wir Objekte, die uns über Jahrzehnte begleiten –
              und Mieter, die das genauso sehen.
            </p>

            <h2 className="font-serif text-3xl sm:text-4xl font-normal tracking-tight pt-6">
              Was uns wichtig ist
            </h2>

            <div className="grid sm:grid-cols-2 gap-x-10 gap-y-8 pt-4">
              {[
                {
                  t: "Respekt vor der Substanz",
                  b: "Stuck, Kastenfenster, Eichendielen – wir bewahren, wo es möglich ist, und ergänzen behutsam, wo es nötig ist.",
                },
                {
                  t: "Energetische Vernunft",
                  b: "Wir denken in Generationen. Dämmung, Heizung und Fenster werden so geplant, dass sie zur Bausubstanz passen.",
                },
                {
                  t: "Faires Miteinander",
                  b: "Unsere Mieter sollen sich zu Hause fühlen. Klar kommunizierte Mieten und eine erreichbare Verwaltung sind selbstverständlich.",
                },
                {
                  t: "Regionale Handwerker",
                  b: "Wir arbeiten dauerhaft mit oberfränkischen Handwerksbetrieben zusammen, die wir kennen und denen wir vertrauen.",
                },
              ].map((it) => (
                <div key={it.t} className="border-l border-primary/40 pl-5">
                  <h3 className="font-serif text-xl mb-2 text-primary">{it.t}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">{it.b}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Verbunden mit der Region */}
      <section className="px-6 md:px-12 lg:px-24 pb-24" data-testid="ueber-uns-region">
        <div className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-primary mb-6">
          <span className="inline-block w-2 h-2 bg-accent" />
          Verbunden mit der Region
        </div>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight leading-tight max-w-3xl">
          Echte Häuser, echte Straßen <em className="italic">und ehrliches Miteinander.</em>
        </h2>
      </section>

      {/* Quote */}
      <section className="bg-muted/40 border-y border-border px-6 md:px-12 lg:px-24 py-24">
        <blockquote className="max-w-4xl mx-auto text-center">
          <p className="font-serif text-3xl sm:text-4xl lg:text-5xl italic font-light leading-[1.25] text-foreground">
            „Eine langfristige Partnerschaft ist uns immer wichtiger, als
            kurzfristige Optimierungspotenziale voll auszuschöpfen.“
          </p>
          <footer className="mt-8 text-xs uppercase tracking-[0.3em] text-muted-foreground">
            Unsere Grundhaltung
          </footer>
        </blockquote>
      </section>

      {/* CTA */}
      <section className="px-6 md:px-12 lg:px-24 py-24 text-center">
        <h2 className="font-serif text-4xl sm:text-5xl font-light leading-tight tracking-tight">
          Lernen Sie uns persönlich kennen.
        </h2>
        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/kontakt">
            <Button className="rounded-none bg-primary hover:bg-primary/90 text-primary-foreground h-12 px-8 text-sm tracking-wide">
              Kontakt aufnehmen <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
          <Link to="/referenzen">
            <Button variant="outline" className="rounded-none border-foreground/30 bg-transparent text-foreground hover:bg-foreground hover:text-background h-12 px-8 text-sm tracking-wide">
              Portfolio ansehen
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
}
